export default __webpack_public_path__ + "static/media/auteuil17.34f69f93.jpg";